/**
 * The one place the nav breakpoint lives (decision 34): at or above it the nav is a sticky left column,
 * below it a compact stepper. Layout switches through useMediaQuery, not CSS media queries, so the
 * number exists only here.
 */
export const NAV_BREAKPOINT = 900;

export const WIDE_LAYOUT_QUERY = `(min-width: ${NAV_BREAKPOINT}px)`;

/**
 * Field-grid breakpoints (decision 51). A block's `layout.columns` gives the column count per size: `mobile`
 * below 640px, `tablet` from 640px, `desktop` from 1024px. A block without a layout is one column below 640px
 * and auto-fills 200px columns above it.
 */
export const GRID_TABLET_MIN = 640;
export const GRID_DESKTOP_MIN = 1024;
export const GRID_TABLET_QUERY = `(min-width: ${GRID_TABLET_MIN}px)`;
export const GRID_DESKTOP_QUERY = `(min-width: ${GRID_DESKTOP_MIN}px)`;

export type GridSize = 'mobile' | 'tablet' | 'desktop';

/** The candidate's "reduce motion" setting: no smooth scrolling, no animated progress or skeleton */
export const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
